import * as React from 'react';
import { connect } from 'react-redux';
import * as urls from '../shared/urls';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import WorkflowStep from './WorkflowStep';
import {
  IWorkflow,
  IWorkflowStep,
  IWorkflowTrigger,
  IWorkflowCondition,
  IWorkflowExecute,
  IWorkflowQueue,
  ISetting,
} from './business-objects/common';
import {
  getWorkflows,
  saveWorkflow,
  getApplicationSetting,
  saveApplicationSetting,
} from './redux-objects/actions';
import SelectList from '../RBSelectList/RBSelectList';
import { Button, Col, Form, Row } from 'react-bootstrap';
import './assets/workflowadmin.css';
import { toast } from 'react-toastify';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import { listForms } from '../../services/formIOService';
import { settings } from '../../services/settingsService';

interface IWorkflowStateProps {
  workflows: IWorkflow[];
  queues: IWorkflowQueue[];
  webServiceURL: string;
  getWorkflows?: (url: string) => Promise<void>;
  saveWorkflow?: (url: string, workflow: IWorkflow) => void;
  saveApplicationSetting?: (url: string, setting: ISetting) => Promise<ISetting>;
  getApplicationSetting?: (url: string) => Promise<ISetting>;
  triggerDriverReportHoldRelease?: (url: string) => Promise<boolean>;
}

interface IWorkflowLocalState {
  selectedWorkflowId: number;
  selectedWorkflow?: IWorkflow;
  selectedStepId?: number;
  driverHeldDaySetting?: ISetting;
  logWorkflowErrorsSetting?: ISetting;
  logWorkflowChangesSetting?: ISetting;
  processingHeldReleases: boolean;
  forms: { name: string, value: string }[];
}

const initialState: IWorkflowLocalState = {
  selectedWorkflowId: -1,
  processingHeldReleases: false,
  forms: [],
};

interface IWorkflowAdminProps extends IWorkflowStateProps { }

class WorkflowAdmin extends React.Component<
  IWorkflowAdminProps,
  IWorkflowLocalState
> {
  public constructor(props: IWorkflowAdminProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.props
      .getWorkflows(`${this.props.webServiceURL}Workflow/GetAllWorkflows`)
      .then(() => this.setSelectedWorkflow());

    this.props
      .getApplicationSetting(`${urls.GET_SETTINGS}?name=${settings.DriverReportHeldDays}`)
      .then((data: ISetting) => {
        this.setState({ driverHeldDaySetting: data });
      });

    this.props
      .getApplicationSetting(`${urls.GET_SETTINGS}?name=${settings.LogWorkflowChanges}`)
      .then((data: ISetting) => {
        this.setState({ logWorkflowChangesSetting: data });
      });
      
    this.props
      .getApplicationSetting(`${urls.GET_SETTINGS}?name=${settings.LogWorkflowErrors}`)
      .then((data: ISetting) => {
        this.setState({ logWorkflowErrorsSetting: data });
      });

    listForms().then(forms => {
      let formData = forms.map(form => ({ name: form.title, value: form._id }));
      formData = [{
        name: 'None',
        value: null,
      }, ...formData];
      this.setState({ forms: formData });
    });
  }

  handleDriverReportHeldDaysSave = () => {
    this.props
      .saveApplicationSetting(urls.SAVE_SETTING, this.state.driverHeldDaySetting)
      .then((result) => {
        if (result) {
          toast.success('Saved', { position: 'bottom-right' });
        } else {
          toast.error('Error Saving :(', { position: 'bottom-right' });
        }
      });
  };

  handleTriggerRelease = () => {
    this.setState({ processingHeldReleases: true });
    Api.post(urls.COMPLETE_HELD_DRIVER_REPORTS_KEYWORDS).then((response: ApiResponse<any>) => {
      this.setState({ processingHeldReleases: false });
      if (response.ok) {
        toast.success('Saved', { position: 'bottom-right' });
      } else {
        console.log(response);
        toast.error('Error Saving :(', { position: 'bottom-right' });
      }
    });
  }

  handleWorkflowChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState(
      {
        selectedWorkflowId: el.value,
      },
      () => this.setSelectedWorkflow()
    );
  };

  setSelectedWorkflow() {
    this.setState({
      selectedWorkflow: this.props.workflows.filter(
        (x) => x.id == this.state.selectedWorkflowId
      )[0],
    });
  }

  handleStepChange = (e: React.FormEvent, stepId: number) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    switch (el.dataset.field) {
      case 'name':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map((x) =>
              x.id == stepId ? { ...x, name: el.value } : x
            ),
          },
        });
        break;
      case 'stepnumber':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map((x) =>
              x.id == stepId ? { ...x, stepNumber: el.value } : x
            ),
          },
        });
        break;
      case 'hasHoldOnComplete':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map((x) =>
              x.id == stepId ? { ...x, hasHoldOnComplete: el.checked } : x
            ),
          },
        });
        break;
      case 'requiredstep':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
              (step) =>
                step.id == stepId
                  ? {
                    ...step,
                    requiredSteps:
                      el.checked == true
                        ? [
                          ...step.requiredSteps,
                          {
                            id: Math.floor(Math.random() * 10000) + 10000,
                            workflowStepId: stepId,
                            requiredStepId: Number(el.dataset.reqid),
                          },
                        ]
                        : step.requiredSteps.filter(
                          (rs) =>
                            rs.requiredStepId.toString() != el.dataset.reqid
                        ),
                  }
                  : step
            ),
          },
        });
        break;
      case 'workflowQueue':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
              (step) =>
                step.id == stepId
                  ? {
                    ...step,
                    workflowStepQueues:
                      el.checked == true
                        ? [
                          ...step.workflowStepQueues,
                          {
                            id: Math.floor(Math.random() * 10000) + 10000,
                            workflowStepId: stepId,
                            workflowQueueId: Number(el.dataset.queueid),
                          },
                        ]
                        : step.workflowStepQueues.filter(
                          (q) =>
                            q.workflowQueueId.toString() !=
                            el.dataset.queueid
                        ),
                  }
                  : step
            ),
          },
        });
        break;
      case 'formIoFormId':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map((x) =>
              x.id == stepId ? { ...x, formIoFormId: el.value } : x
            ),
          },
        });
        break;
    }
  };

  handleTriggerChange = (e: React.FormEvent, trigger: IWorkflowTrigger) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    switch (el.dataset.field) {
      case 'name':
        this.setState({
          selectedWorkflow: {
            ...this.state.selectedWorkflow,
            workflowSteps: this.state.selectedWorkflow.workflowSteps.map((x) =>
              x.id == trigger.workflowStepId
                ? {
                  ...x,
                  triggers: x.triggers.map((y) =>
                    y.id == trigger.id ? { ...y, name: el.value } : y
                  ),
                }
                : x
            ),
          },
        });
        break;
    }
  };

  handleConditionChange = (
    e: React.FormEvent,
    condition: IWorkflowCondition,
    dataField: string
  ) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
          (step) => ({
            ...step,
            triggers: step.triggers.map((iTrigger) =>
              iTrigger.id == condition.workflowTriggerId
                ? {
                  ...iTrigger,
                  workflowTriggerConditions: iTrigger.workflowTriggerConditions.map(
                    (cond) =>
                      cond.id == condition.id
                        ? {
                          ...cond,
                          conditionValue:
                            dataField == 'value'
                              ? el.value
                              : dataField == 'type'
                                ? null
                                : condition.conditionValue,
                          workflowConditionTypeId:
                            dataField == 'type'
                              ? el.value
                              : condition.workflowConditionTypeId,
                          additionalDetails:
                            dataField == 'details'
                              ? el.value
                              : condition.additionalDetails,
                        }
                        : cond
                  ),
                }
                : iTrigger
            ),
          })
        ),
      },
    });
  };

  handleExecuteChange = (
    e: React.FormEvent,
    execute: IWorkflowExecute,
    dataField: string
  ) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
          (step) => ({
            ...step,
            triggers: step.triggers.map((iTrigger) =>
              iTrigger.id == execute.workflowTriggerId
                ? {
                  ...iTrigger,
                  workflowTriggerExecutes: iTrigger.workflowTriggerExecutes.map(
                    (ex) =>
                      ex.id == execute.id
                        ? {
                          ...ex,
                          executeValue:
                            dataField == 'value'
                              ? el.value
                              : dataField == 'type'
                                ? null
                                : execute.executeValue,
                          workflowExecuteTypeId:
                            dataField == 'type'
                              ? el.value
                              : execute.workflowExecuteTypeId,
                          additionalDetails:
                            dataField == 'details'
                              ? el.value
                              : execute.additionalDetails,
                        }
                        : ex
                  ),
                }
                : iTrigger
            ),
          })
        ),
      },
    });
  };

  addStep = () => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: [
          ...this.state.selectedWorkflow.workflowSteps,
          {
            id: Math.floor(Math.random() * 10000) + 10000,
            name: 'New Step',
            isOptional: false,
            workflowId: this.state.selectedWorkflow.id,
            stepNumber: this.maxStep() + 1,
            triggers: [],
            hasHoldOnComplete: false,
          },
        ],
      },
    });
  };

  addTrigger = (curStep: IWorkflowStep) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map((iStep) =>
          iStep.id == curStep.id
            ? {
              ...iStep,
              triggers: [
                ...iStep.triggers,
                {
                  workflowStepId: iStep.id,
                  id: Math.floor(Math.random() * 10000) + 10000, // random number above 10000
                  name: 'New Trigger',
                  workflowTriggerConditions: [],
                  workflowTriggerExecutes: [],
                },
              ],
            }
            : iStep
        ),
      },
    });
  };

  addCondition = (trigger: IWorkflowTrigger) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map((step) =>
          step.id == trigger.workflowStepId
            ? {
              ...step,
              triggers: step.triggers.map((iTrigger) =>
                iTrigger.id == trigger.id
                  ? {
                    ...trigger,
                    workflowTriggerConditions: [
                      ...iTrigger.workflowTriggerConditions,
                      {
                        id: Math.floor(Math.random() * 10000) + 10000, // random number above 10000,
                        workflowTriggerId: iTrigger.id,
                        workflowConditionTypeId: -1,
                        conditionValue: '2',
                        additionalDetails: null,
                      },
                    ],
                  }
                  : iTrigger
              ),
            }
            : step
        ),
      },
    });
  };

  addExecute = (trigger: IWorkflowTrigger) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map((step) =>
          step.id == trigger.workflowStepId
            ? {
              ...step,
              triggers: step.triggers.map((iTrigger) =>
                iTrigger.id == trigger.id
                  ? {
                    ...trigger,
                    workflowTriggerExecutes: [
                      ...iTrigger.workflowTriggerExecutes,
                      {
                        id: Math.floor(Math.random() * 10000) + 10000, // random number above 10000,
                        workflowTriggerId: iTrigger.id,
                        workflowExecuteTypeId: -1,
                        executeValue: null,
                        additionalDetails: null,
                      },
                    ],
                  }
                  : iTrigger
              ),
            }
            : step
        ),
      },
    });
  };

  maxStep() {
    if (
      !this.state.selectedWorkflow.workflowSteps ||
      this.state.selectedWorkflow.workflowSteps.length == 0
    )
      return 0;

    return this.state.selectedWorkflow.workflowSteps.reduce((prev, current) => {
      return prev.stepNumber > current.stepNumber ? prev : current;
    }).stepNumber;
  }

  // maybe use later or delete
  getAllTriggers = () => {
    var triggers = this.state.selectedWorkflow.workflowSteps.reduce(
      (accumulator, currentvalue) => {
        return [...accumulator, ...currentvalue.triggers];
      },
      []
    );
    //console.log('all the triggers', triggers);
  };

  removeStep = (id: number) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.filter((x) => {
          return x.id != id;
        }),
      },
    });
  };

  removeTrigger = (id: number) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
          (step) => ({
            ...step,
            triggers: step.triggers.filter((x) => {
              return x.id != id;
            }),
          })
        ),
      },
    });
  };

  removeTriggerCondition = (id: number) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
          (step) => ({
            ...step,
            triggers: step.triggers.map((f) => ({
              ...f,
              workflowTriggerConditions: f.workflowTriggerConditions.filter(
                (x) => {
                  return x.id != id;
                }
              ),
            })),
          })
        ),
      },
    });
  };

  removeTriggerExecute = (id: number) => {
    this.setState({
      selectedWorkflow: {
        ...this.state.selectedWorkflow,
        workflowSteps: this.state.selectedWorkflow.workflowSteps.map(
          (step) => ({
            ...step,
            triggers: step.triggers.map((f) => ({
              ...f,
              workflowTriggerExecutes: f.workflowTriggerExecutes.filter((x) => {
                return x.id != id;
              }),
            })),
          })
        ),
      },
    });
  };

  handledriverHeldDaySettingChange = (event) => {
    const { name, value, type } = event.target;
    this.setState({
      driverHeldDaySetting: { ...this.state.driverHeldDaySetting, value },
    });
  };

  handlelogWorkflowChangesChange = (event) => {
    const settingValue = event.target.checked ? "yes" : "no";
    this.setState({
      logWorkflowChangesSetting: { ...this.state.logWorkflowChangesSetting, value: settingValue },
    }, () => {
      this.props.saveApplicationSetting(urls.SAVE_SETTING, this.state.logWorkflowChangesSetting)
      .then((result) => {
        if (result) {
          toast.success('Saved', { position: 'bottom-right' });
        } else {
          toast.error('Error Saving :(', { position: 'bottom-right' });
        }
      });
    });
  };

  handlelogWorkflowErrorsChange = (event) => {
    const settingValue = event.target.checked ? "yes" : "no";
    this.setState({
      logWorkflowErrorsSetting: { ...this.state.logWorkflowErrorsSetting, value: settingValue },
    }, () => {
      this.props.saveApplicationSetting(urls.SAVE_SETTING, this.state.logWorkflowErrorsSetting)
      .then((result) => {
        if (result) {
          toast.success('Saved', { position: 'bottom-right' });
        } else {
          toast.error('Error Saving :(', { position: 'bottom-right' });
        }
      });
    });
  };

  saveWorkflow = () => {
    this.props.saveWorkflow(
      `${this.props.webServiceURL}Workflow/SaveWorkflow`,
      this.state.selectedWorkflow
    );
  };

  public render() {
    const workflowListData = this.props.workflows.map((workflow) => {
      return { name: workflow.name, value: workflow.id };
    });
    if (this.state.selectedWorkflow) {
      this.state.selectedWorkflow.workflowSteps.sort(
        (x, y) => x.stepNumber - y.stepNumber
      );
    }
    //console.log('state of workflow', this.state.selectedWorkflow);
    return (
      workflowListData &&
      workflowListData.length > 0 && (
        <React.Fragment>
          <div className='divWorkflowAdmin'>
            <b>Workflow:</b>
            <SelectList
              data={workflowListData}
              value={this.state.selectedWorkflowId.toString()}
              onChange={this.handleWorkflowChange}
            />
            <hr />
            <Button
              className='float-right'
              size='sm'
              variant='success'
              onClick={this.saveWorkflow}
            >
              Save Workflow
            </Button>
            {this.state.selectedWorkflow && (
              <div>
                <h3>
                  {this.state.selectedWorkflow.name} Steps &nbsp;&nbsp;
                  <i
                    className='fas fa-plus-square pointer'
                    onClick={this.addStep}
                    title='Add Step'
                  ></i>
                </h3>
                {this.state.selectedWorkflow &&
                  this.state.selectedWorkflow.workflowSteps &&
                  this.state.selectedWorkflow.workflowSteps.length > 0 && (
                    <Tabs
                      defaultActiveKey={
                        this.state.selectedWorkflow.workflowSteps[0].id
                      }
                      id='step-tabs'
                    >
                      {this.state.selectedWorkflow.workflowSteps.map(
                        (step, index) => {
                          return (
                            <Tab
                              eventKey={step.id.toString()}
                              title={step.stepNumber + ') ' + step.name}
                              key={step.id}
                            >
                              <br />
                              <WorkflowStep
                                key={step.id}
                                step={step}
                                steps={
                                  this.state.selectedWorkflow.workflowSteps
                                }
                                queues={this.props.queues}
                                forms={this.state.forms}
                                addCondition={this.addCondition}
                                addExecute={this.addExecute}
                                handleStepChange={this.handleStepChange}
                                handleTriggerChange={this.handleTriggerChange}
                                handleConditionChange={
                                  this.handleConditionChange
                                }
                                handleExecuteChange={this.handleExecuteChange}
                                removeStep={this.removeStep}
                                removeTrigger={this.removeTrigger}
                                removeTriggerCondition={
                                  this.removeTriggerCondition
                                }
                                removeTriggerExecute={this.removeTriggerExecute}
                                addTrigger={this.addTrigger}
                              />
                            </Tab>
                          );
                        }
                      )}
                    </Tabs>
                  )}
              </div>
            )}
          </div>
          <div>
            <br />
            <br />
            <br />
            <br />
            <hr />
            <br />
            <h5>System Workflow Settings</h5>
              <Form>
                {this.state.driverHeldDaySetting && (
                  <Form.Group as={Row} controlId='formPlaintextEmail'>
                    <Form.Label column sm='2'>
                      <b>Driver Report Held Days: </b>
                    </Form.Label>
                    <Col sm='1'>
                      <Form.Control
                        type='number'
                        value={this.state.driverHeldDaySetting.value}
                        onChange={this.handledriverHeldDaySettingChange}
                      />
                    </Col>
                    <Button
                      className=''
                      size='sm'
                      variant='success'
                      onClick={this.handleDriverReportHeldDaysSave}
                    >
                      Save
                    </Button>
                  </Form.Group>                
                 )}
                <Form.Group as={Row} controlId='formPlaintextEmail'>
                  <Form.Label column sm='3'>
                    <b>Trigger 30 Day release process: </b>
                  </Form.Label>
                  {!this.state.processingHeldReleases && (
                    <Button
                      className=''
                      size='sm'
                      variant='warning'
                      onClick={this.handleTriggerRelease}
                    >
                      Now
                    </Button>
                  )}
                  {this.state.processingHeldReleases && (
                    <div>
                      Working {'   '}
                      <img
                        src={require('../../../src/assets/SmartAdmin/img/32/Marty.gif')}
                      />
                    </div>
                  )}
                </Form.Group>
                {this.state.logWorkflowChangesSetting && (
                  <Form.Group as={Row} >
                  <Form.Label column sm='3'>
                      <b>Log Workflow Changes: </b>
                    </Form.Label>
                  <Form.Check // prettier-ignore
                      type="switch"
                      id="custom-switch1"
                      className="custom-switch-md"
                      checked={this.state.logWorkflowChangesSetting.value === "yes"}
                      onChange={(e) =>
                        this.handlelogWorkflowChangesChange(e)
                      }
                    />
                  </Form.Group>                
                )}
                {this.state.logWorkflowErrorsSetting && (
                <Form.Group as={Row} >
                <Form.Label column sm='3'>
                    <b>Log Workflow Errors: </b>
                  </Form.Label>
                <Form.Check // prettier-ignore
                    type="switch"
                    id="custom-switch2"
                    className="custom-switch-md"
                    checked={this.state.logWorkflowErrorsSetting.value === "yes"}
                    onChange={(e) =>
                      this.handlelogWorkflowErrorsChange(e)
                    }
                  />
                </Form.Group>
                )}
              </Form>
          </div>
        </React.Fragment>
      )
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    workflows: state.Workflow.workflows,
    queues: state.Workflow.queues,
  };
}

const mapDispatchToProps = {
  getWorkflows,
  saveWorkflow,
  getApplicationSetting,
  saveApplicationSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowAdmin);
